import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import Swipe from 'react-easy-swipe'

export const SwipeableDrawer = (props) => {
  const { open, width, children, anchor, handleClose } = props

  const [isOpen, setIsOpen] = useState(open)

  useEffect(() => {
    setIsOpen(open)
  }, [open])

  useEffect(() => {
    if (!isOpen) return

    const scrollY = window.scrollY

    const lockScroll = () => {
      document.body.classList.toggle('body-scroll-lock', true)
    }

    const unlockScroll = () => {
      document.body.classList.toggle('body-scroll-lock', false)
    }

    lockScroll()

    const handleResize = () => {
      if (window.innerWidth >= 1025) {
        unlockScroll()
      }
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      unlockScroll()
    }
  }, [isOpen])

  const onSwipeMove = (position, event) => {
    if (isOpen && position.x < 0) {
      return closeDrawer()
    } else if (!isOpen && position.x > 0) {
      return openDrawer()
    }
  }

  const openDrawer = () => setIsOpen(true)
  const closeDrawer = () => {
    setIsOpen(false)
    handleClose()
  }

  return (
    <StyledSwipe
      allowMouseEvents
      swipeWidth={width}
      isOpen={isOpen}
      onSwipeMove={onSwipeMove}
      anchor={anchor}
    >
      <div className='drawer__content-container'>
        <div className='drawer__content-container--inner'>
          {children}
        </div>
      </div>
    </StyledSwipe>
  )
}

SwipeableDrawer.defaultProps = {
  open: false,
  anchor: 'left',
  handleClose: () => {}
}

export default SwipeableDrawer

const StyledSwipe = styled(Swipe)`
  z-index: ${props => props.theme.zIndex.drawer};
  background-color: transparent;
  display: inline-block;
  height: 100vh;
  padding-left: 10px;
  position: fixed;
  left: ${props => props.anchor === 'left' ? '0' : 'auto'};
  right: ${props => props.anchor === 'right' ? '0' : 'auto'};
  top: 0;
  
  .drawer__content-container {
    position: absolute;
    left: ${props => props.anchor === 'left' ? '0' : 'auto'};
    right: ${props => props.anchor === 'right' ? '0' : 'auto'};
    top: 0;
    background-color: ${props => props.theme.palette.background.paper};
    box-shadow: ${props => props.isOpen ? props.theme.shadows.main : 'none'};
    width: ${props => {
      switch (true) {
        case props.isOpen && props.width:
          return props.width + 'px'
        case props.isOpen && !props.width:
          return 'calc(100vw - 20px)'
        default:
          return '0'
      }
    }};
    height: 100%;
    color: ${props => props.theme.palette.text.main};
    font-family: ${props => props.theme.typography.fontFamily};
    overflow: hidden;
    transition: width 800ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  }
  
  .drawer__content-container--inner {
    padding: 0 10px;
    width: 100%;
    height: 100%;
  }
`
